<template>
  <main>
    <loading :active.sync="isLoading"></loading>
    <KTCodePreview class="px-10">
      <template v-slot:preview>
        <div class="w-100 d-flex align-items-center justify-space-between mb-6">
          <b-card-title class="m-0">{{$t("AddOnFaceAuthenticationProjectList")}}</b-card-title>
          <router-link to="/dashboard/kyc-create-add-on" tag="a" >
            <b-button variant="primary" class="text-uppercase">{{$t("CreateNewProject")}}</b-button>
          </router-link>
        </div>
        <div v-if="items.length">
          <v-data-table
              loading-text="Getting the data."
              :loading="loading"
              :headers="headers"
              :items="items"
              :items-per-page="30"
              :page.sync="page"
              hide-default-footer>
            <template v-slot:item.status="{ item }">
              <v-chip :color="getColor(item.status)" class="text-white text-uppercase font-weight-boldest">
                {{ $t(item.status) }}
              </v-chip>
            </template>
            <template v-slot:item.id="{ item }">
              <router-link :to="`/dashboard/kyc-add-on-detail/${item.id}`">
                <v-btn color="warning">{{$t('Edit')}}</v-btn>
              </router-link>
            </template>
            <template v-slot:item.authId="{ item }">
              <router-link :to="`/dashboard/kyc-add-on-auth-ids/${item.id}`">
                <v-btn color="primary">{{$t("View")}}</v-btn>
              </router-link>
            </template>
          </v-data-table>
        </div>
        <b-col v-if="items.length === 0 && !isLoading" class="d-flex flex-column align-items-center justify-content-center text-center" style="height: 200px;">
          <h3>{{$t("NoAddOnProject-1")}}</h3>
          <h3>{{$t("NoAddOnProject-2")}}</h3>
          <h3>{{$t("NoAddOnProject-3")}}</h3>
        </b-col>
      </template>
    </KTCodePreview>
  </main>
</template>


<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {API} from "aws-amplify";

export default {
  name: 'KycAddOnList',
  components: {KTCodePreview},
  async mounted() {
    try{
      this.isLoading = true;
      const {response : projectList , statusCode , message} = await this.getProjectList();
      if (statusCode === 200) {
        this.items = [...projectList.map((item) => {
          return {
            title : item.name,
            description : item.description,
            status : item.status,
            total : item.totalCount,
            id : item.faceAuth_projectId,
          }
        })];
      } else {
        throw new Error(message || 'Error');
      }
    }catch (e) {
      console.log(e)
      this.$swal({
        title: "Error",
        text: "There is an error while getting the project list.Please Retry",
        icon: "error",
      })
    } finally {
      this.isLoading = false;
    }
  },
  created() {
    this.headers = this.getTableHeaders
  },
  data: () => ({
    isLoading: false,
    page : 1,
    headers: [],
    items: [],
  }),

  methods : {
    getColor (status) {
      const lowerStatus = status.toLowerCase();
      if (lowerStatus === 'service') return 'green'
      if (lowerStatus === 'closed') return 'red'
      if (lowerStatus === 'test') return 'orange'
      return 'red';
    },
    async getProjectList() {
      try {
        const projectId = this.$store.getters.getSelectedProjectId;
        const email = this.$store.getters.currentLoginUser.email;

        this.$store.dispatch(SET_BREADCRUMB, [{title: "Face Add On"}]);

        return await API.get('apiArgosDashboard', '/addOnProject' , {
          queryStringParameters: {
            alias : this.$store.getters.getEnv,
            email,
            projectId,
            isDashboard : true
          }
        });
      } catch (e) {
        console.log(e)
        return {
          statusCode : 404,
          response : [],
        }
      }
    }
  },
  computed: {
    sliderColor() {
      if (this.selectedArgosScore.score >= 0 && this.selectedArgosScore.score <= 25) return 'red';
      if (this.selectedArgosScore.score >= 26 && this.selectedArgosScore.score <= 50) return 'orange';
      if (this.selectedArgosScore.score >= 51 && this.selectedArgosScore.score <= 80) return 'indigo';
      if (this.selectedArgosScore.score >= 81) return 'green';
      return 'red'
    },
    getTableHeaders() {
      return [
        {text: this.$t("Edit"), value: 'id', sortable: false},
        {text: this.$t("ProjectName"), value: 'title', align: 'start', sortable: false},
        {text: this.$t("ProjectStatus"), align: 'center', value: 'status'},
        {text: this.$t("TotalCount"), align: 'center', value: 'total'},
        {text: this.$t("Description"), value: 'description', class: 'description-column'},
        {text: this.$t("AuthIdList"), value: 'authId', sortable: false},
      ]
    },
  },
  watch : {
    "$i18n.locale": {
      handler() {
        this.headers = this.getTableHeaders
      },
    }
  }

}
</script>